export default {
    Auth: {
        region: 'us-east-1',
        userPoolId: 'us-east-1_2bi5zk900',
        userPoolWebClientId: '3chheq2luo7hunf4s7bj8cob9t',
        //   identityPoolId: 'us-east-1:fea6244e-8a7d-4cd5-8432-b8bd2bd8076a'
    },
    API: {
        endpoints: [{
            name: "Get-User-Tour",
            region: "us-east-1",
            endpoint: " https://tcr8bkmcgl.execute-api.us-east-1.amazonaws.com/dev1/api/get-user-tour"
        }]
    },
    //   Storage: {
    //       bucket: 'fooddoneit-production-tours',
    //       region: 'us-east-1', //OPTIONAL -  Amazon service region
    //   }
}